import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import { UserType } from '@wizbii/webservices';
import { Observable } from 'rxjs';

export interface AbTestApiConfig {
  baseUrl: string;
  appId: string;
}

export enum AbTestVersions {
  Default = 'A',
  B = 'B',
}

export const ABTEST_CONFIG_API = new InjectionToken<AbTestApiConfig>('ABTEST_CONFIG_API');

@Injectable()
export class AbTestWebservice {
  private readonly baseUrl: string;
  private readonly appId: string;

  constructor(private readonly httpClient: HttpClient, @Inject(ABTEST_CONFIG_API) { appId, baseUrl }: AbTestApiConfig) {
    this.baseUrl = baseUrl;
    this.appId = appId;
  }

  getVersion(campaignId: string, userType: UserType, userId: string): Observable<{ value: string }> {
    return this.httpClient.get<{ value: string }>(
      `${this.baseUrl}/v1/product/${this.appId}/campaign/${campaignId}/${userType}/${userId}`,
      { withCredentials: true }
    );
  }
}
